import React from "react";

//UI Material
import { Box } from "@mui/material";

//React Charts js
import { Line } from "react-chartjs-2";

export default function AllProductsGraph({ data = [], color = "white" }) {
  //Function to generate datasets
  const generateDataSets = () => {
    //Array of finished dates
    const finishedDates = [];

    for (const order of data) {
      for (const product of order.productsStatus) {
        if (product.status === "FINISHED") {
          finishedDates.push(product.finishedAt);
        }
      }
    }

    let products = [
      {
        label: "Productos",
        data: new Array(12).fill(0),
        borderColor: new Array(12).fill(color),
        backgroundColor: new Array(12).fill(color),
        pointRadius: new Array(12).fill(1),
        tension: 0.2,
      },
    ];

    //Fill order objects iterating trough orders
    for (const date of finishedDates) {
      try {
        const month = new Date(date).getMonth();
        //Validate month
        if (!isNaN(Number(month))) {
          products[0].data[month] += 1;
        }
      } catch (e) {
        console.log(e);
        break;
      }
    }

    products[0].pointRadius[new Date().getMonth()] = 3;
    products[0].borderColor[new Date().getMonth()] = "#CDF4FF";
    products[0].backgroundColor[new Date().getMonth()] = "#CDF4FF";

    return products;
  };

  //Function to generate chart data
  const generateChartData = () => ({
    datasets: generateDataSets(),
    labels: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Setiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  });

  //Function to generate chart options
  const generateChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      y: { display: false, grid: { display: false } },
      x: { display: false, grid: { display: false } },
    },
    plugins: {
      filler: {
        propagate: true,
      },
      legend: {
        position: "bottom",
        display: false,
      },
    },
  };

  // ==========>Component<==========
  return (
    <Box>
      <Line options={generateChartOptions} data={generateChartData()} />
    </Box>
  );
}
